import { InfoIcon } from '@phosphor-icons/react';

const BlockedBanner = ({ reason, userEmail, className = '' }) => {
  return (
    <div
      className={`border border-dashed border-[var(--q3-danger-normal)] bg-[var(--q3-danger-light)] rounded-lg px-4 py-2.5 ${className}`}
    >
      <div className="flex items-center gap-2 text-[var(--q3-danger-normal)] font-semibold text-sm">
        <InfoIcon size={18} />
        You have been blocked
      </div>

      <ul className="list-disc pl-5 mt-1.5 space-y-0.5 text-xs md:text-sm text-[var(--q3-neutral-default)]">
        <li>You cannot post any new solutions{reason ? ` as your solution ${reason}` : ''}</li>
        <li>Your previously uploaded solutions are still visible to the community, However you cannot edit them.</li>
      </ul>

      <p className="text-xs md:text-sm text-[var(--q3-neutral-default)] mt-1.5">
        If you think this is a mistake you can contact us on{' '}
        <a href="mailto:support@mathongo.com" className="underline text-[var(--q3-blue-normal)]">
          support@mathongo.com
        </a>{' '}
        with your registered email id {userEmail}
      </p>
    </div>
  );
};

export default BlockedBanner;
